import {
	TRIGGER_PREPAID_TXN_STATUS_API_CALL,
	TRIGGER_PREPAID_TXN_STATUS_API_CALL_SUCCESS,
	TRIGGER_CLEAR_PREPAID_TXN_DETAILS,
} from 'redux/actionTypes';

export function triggerPrePaidTxnStatusApiCall(data, callback, stopLoader) {
	return {
		type: TRIGGER_PREPAID_TXN_STATUS_API_CALL,
		data,
		stopLoader,
		callback,
	};
}

export function triggerPrePaidTxnStatusApiCallSuccess(data) {
	return {
		type: TRIGGER_PREPAID_TXN_STATUS_API_CALL_SUCCESS,
		data,
	};
}

export function triggerClearPrePaidTxnDetails(data) {
	return {
		type: TRIGGER_CLEAR_PREPAID_TXN_DETAILS,
		data,
	};
}
